import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import NotAuthorized from '../page/NotAuthorized';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('AUTHORIZED_COMPONENT', LOG_LEVELS.DEBUG);

function mapStateToProps(state, props) {
    const stateProps = {};
    stateProps.currentUser = state.authentication && state.authentication.data;
    return stateProps;
}

const AuthorizedResource = (allowedRoles=[], showNotAuthorized=true) => 
    (OriginalComponent=(<span></span>)) => {
        log.debug('AuthorizedResource(): ', allowedRoles,showNotAuthorized, OriginalComponent)
        return connect(mapStateToProps)(
            class OriginalComponentWithAuthorization extends React.Component {
                render() {
                    log.debug('render(): ', this.props);
                    if( _.isEmpty(this.props.currentUser) || _.isEmpty(this.props.currentUser.role) ) {
                        log.debug('render(): User or roles data not available');
                        //The data may not be available yet
                        return (
                            <span></span>
                        );
                    }
                    const role = this.props.currentUser.role;
                    log.debug('render(): user role: ', role);
                    if(allowedRoles.includes(role)) {
                        log.debug('render(): Allowed! ');
                            return (
                                <OriginalComponent {...this.props} />
                            );
                    } else if(showNotAuthorized){
                        log.debug('render(): Not allowed! ');
                        return (
                            <NotAuthorized />
                        );   
                    } else{
                        log.debug('render(): Not allowed, No show!');
                        return (
                            <span></span>
                        );
                    }
                }
            }
        );
    }

export default AuthorizedResource;
